import { getUserProfile } from "../../../redux/selectors/profileSelectors";
import React, { useEffect, useRef, useState } from "react";
import { Input, Select } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { addTeamMembers, addTeamMembersReset, getCompanyProfileDetails } from "../../../redux/actions";
import { NumericInput } from "../../My Profile/components/NumericInput";
import { getCountryPhoneCode, getFullStateName } from "../../My Profile/components/helper";
import { alertNotification } from "../../../components/TopNotification/alertNotification";
import "./Add Member.css";

const { Option } = Select;

const ALL_PHONE_CODES = getCountryPhoneCode(null, true);
const COUNTRIES = Object.keys(ALL_PHONE_CODES)
  .map((name) => ({
    name,
    iso2: (getFullStateName(name) || "").toLowerCase(),
    code: ALL_PHONE_CODES[name],
  }))
  .filter((c) => c.iso2)
  .sort((a, b) => a.name.localeCompare(b.name));

const getEmailDomain = (email) => {
  const afterAt = email?.split("@")?.[1];
  return afterAt ? afterAt.split(".")[0] : "";
};

const getUserNameFromEmail = (email) => email?.trim().split("@")?.[0] || "";

function Add_Member({ setShowModal, onSuccess }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [flagcode, setFlagcode] = useState("us");
  const [CountryCodeValue, setCountryCodeValue] = useState("1");
  const [MobilePhone, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const successHandledRef = useRef(false);

  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state.TeamMembersReducer.AddMemberloading
  );
  const addSuccess = useSelector((state) => state.TeamMembersReducer.success);

  const response = useSelector((state) => state.TeamMembersReducer.response);
  // const resp = useSelector(
  //   (state) => state.getCompanyProfileDetailsReducer.resp
  // );
  const resp = getUserProfile();
 

  useEffect(() => {
    dispatch(getCompanyProfileDetails());
  }, [dispatch]);

  useEffect(() => {
    if (response === "Sorry this user already exists") {
      setErrors((prev) => ({ ...prev, email: "The email address is already being used" }));
      successHandledRef.current = false;
      dispatch(addTeamMembersReset());
      return;
    }

    if (addSuccess && !successHandledRef.current) {
      successHandledRef.current = true;
      alertNotification("success", "Team member added successfully");
      setShowModal(false);
      dispatch(addTeamMembersReset());
      onSuccess?.();
    }
  }, [addSuccess, response, dispatch, onSuccess, setShowModal]);

  function handleCountryChange(iso2) {
    const country = COUNTRIES.find((c) => c.iso2 === iso2);
    if (country) {
      setFlagcode(country.iso2);
      setCountryCodeValue(country.code);
    }
  }

  function validate() {
    const errs = {};
    const namePattern = /^[a-zA-Z]{2,40}( [a-zA-Z]{2,40})+$/;
    const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const emailDomain = getEmailDomain(email);
    const companyDomain = getEmailDomain(resp?.EmailAddress);
    const phoneDigits = MobilePhone.replace(/\D/g, "");

    if (!fullName.trim()) {
      errs.fullName = "Please add full name";
    } else if (!namePattern.test(fullName.trim())) {
      errs.fullName = "Enter first and last name separated by a space";
    }

    if (!email.trim()) {
      errs.email = "Please add email address.";
    } else if (!emailPattern.test(email.trim())) {
      errs.email = "Please enter a proper email address.";
    } else if (emailDomain && companyDomain && emailDomain !== companyDomain) {
      errs.email = `You must use your company domain email: example name@${companyDomain}.com`;
    }

    if (!jobTitle.trim()) {
      errs.jobTitle = "Please add job title";
    }

    if (!MobilePhone.trim()) {
      errs.phone = "Please add phone number";
    } else if (phoneDigits.length < 10 || phoneDigits.length > 13) {
      errs.phone = "Please enter valid phone number.";
    }

    return errs;
  }

  function handleSubmit() {
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setErrors({});
    successHandledRef.current = false;
    dispatch(
      addTeamMembers({
        EmailAddress: email.trim(),
        FullName: fullName.trim(),
        CompanyName: "manuallyadded",
        UserName: getUserNameFromEmail(email),
        JobTitle: jobTitle.trim(),
        PhoneNumber: `${CountryCodeValue}${MobilePhone}`,
        Source: "manual",
      })
    );
  }

  // Same flagselection pattern as personalDetails.js — flag image from flagcdn + country code
  const flagselection = (
    <Select
      value={flagcode}
      onChange={handleCountryChange}
      className="am-country-dropdown"
      dropdownMatchSelectWidth={false}
      bordered={false}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
    >
      {COUNTRIES.map((c) => (
        <Option key={c.iso2} value={c.iso2} label={`${c.name} +${c.code}`}>
          <div className="am-country-option">
            <img
              src={`https://flagcdn.com/w40/${c.iso2}.png`}
              alt={c.name}
              className="am-flag-img"
            />
            <span className="roleExperience-Mobile-code">+{c.code}</span>
          </div>
        </Option>
      ))}
    </Select>
  );

  return (
    <div className="am-form">
      <h2 className="am-title">Add Member</h2>
      <hr className="am-divider" />

      {/* Full Name */}
      <div className="am-field">
        <label className="am-label">
          Full Name <span className="am-required">*</span>
        </label>
        <Input
          className={`am-input ${errors.fullName ? "am-input-error" : ""}`}
          placeholder="Enter full name"
          maxLength={50}
          value={fullName}
          onChange={(e) => {
            setFullName(e.target.value);
            setErrors((prev) => ({ ...prev, fullName: "" }));
          }}
        />
        <div className="am-input-footer">
          {errors.fullName ? (
            <span className="am-err-text">{errors.fullName}</span>
          ) : (
            <span />
          )}
          <span className="am-counter">{fullName.length}/50</span>
        </div>
      </div>

      {/* Work Email */}
      <div className="am-field">
        <label className="am-label">
          Work Email <span className="am-required">*</span>
        </label>
        <Input
          className={`am-input ${errors.email ? "am-input-error" : ""}`}
          placeholder="Enter work email"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setErrors((prev) => ({ ...prev, email: "" }));
          }}
        />
        {errors.email && <span className="am-err-text">{errors.email}</span>}
      </div>

      {/* Job Title */}
      <div className="am-field">
        <label className="am-label">
          Job Title <span className="am-required">*</span>
        </label>
        <Input
          className={`am-input ${errors.jobTitle ? "am-input-error" : ""}`}
          placeholder="Enter job title"
          value={jobTitle}
          onChange={(e) => {
            setJobTitle(e.target.value);
            setErrors((prev) => ({ ...prev, jobTitle: "" }));
          }}
        />
        {errors.jobTitle && <span className="am-err-text">{errors.jobTitle}</span>}
      </div>

      {/* Mobile Number — same NumericInput + flagselection as personalDetails.js */}
      <div className="am-field">
        <label className="am-label">
          Mobile Number <span className="am-required">*</span>
        </label>
        <NumericInput
          className={`number-div ${errors.phone ? "am-input-error" : ""}`}
          flagselection={flagselection}
          value={MobilePhone}
          onChange={(val) => {
            setPhoneNumber(val);
            setErrors((prev) => ({ ...prev, phone: "" }));
          }}
          changesflag={() => {}}
          setcustomMessage={() => {}}
        />
        <div className="am-input-footer">
          {errors.phone ? (
            <span className="am-err-text">{errors.phone}</span>
          ) : (
            <span />
          )}
          <span className="am-counter">{MobilePhone.replace(/\D/g, "").length}/13</span>
        </div>
      </div>

      {/* Submit */}
      <button className="am-submit-btn" onClick={handleSubmit} disabled={loading}>
        {loading ? <LoadingOutlined /> : <><PlusOutlined /> Add Member</>}
      </button>
    </div>
  );
}

export default Add_Member;
